import { render, staticRenderFns } from "./productReturn.vue?vue&type=template&id=6cf4783a&scoped=true&"
import script from "./productReturn.vue?vue&type=script&lang=js&"
export * from "./productReturn.vue?vue&type=script&lang=js&"
import style0 from "./productReturn.vue?vue&type=style&index=0&id=6cf4783a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf4783a",
  null
  
)

export default component.exports